import {Platform, PermissionsAndroid, Linking} from 'react-native';
import DeviceInfo from 'react-native-device-info';
// import RNFS from 'react-native-fs';
const RNFS = Platform.OS === 'web' ? null : require('react-native-fs');

// ==========================
// گرفتن ورژن فعلی اپ
// ==========================
const getCurrentVersion = () => DeviceInfo.getVersion();

// ==========================
// مقایسه نسخه‌ها
// ==========================
const compareVersions = (v1, v2) => {
  const a = v1.split('.').map(Number);
  const b = v2.split('.').map(Number);
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const diff = (a[i] || 0) - (b[i] || 0);
    if (diff > 0) return 1;
    if (diff < 0) return -1;
  }
  return 0;
};

// ==========================
// درخواست مجوز نصب APK
// ==========================
const requestInstallPermission = async () => {
  if (Platform.OS === 'android' && Platform.Version >= 26) {
    const granted = await PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.REQUEST_INSTALL_PACKAGES,
      {
        title: 'مجوز نصب برنامه',
        message: 'برای نصب APK نیاز به این مجوز داریم',
        buttonNeutral: 'بعداً',
        buttonNegative: 'رد',
        buttonPositive: 'موافقم',
      },
    );
    return granted === PermissionsAndroid.RESULTS.GRANTED;
  }
  return true;
};

// ==========================
// دانلود و نصب APK خودکار
// ==========================
const downloadAndInstallApk = async apkUrl => {
  try {
    if (Platform.OS !== 'android') return;

    // مجوز ذخیره‌سازی
    const storageGranted = await PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,
      {
        title: 'مجوز ذخیره‌سازی',
        message: 'برای دانلود به مجوز ذخیره‌سازی نیاز داریم',
        buttonNeutral: 'بعداً',
        buttonNegative: 'رد',
        buttonPositive: 'موافقم',
      },
    );

    if (storageGranted !== PermissionsAndroid.RESULTS.GRANTED) return;

    // const downloadDest = `${RNFS.DownloadDirectoryPath}/update.apk`;
    const downloadDest = `${RNFS.DocumentDirectoryPath}/update.apk`;
    const ret = RNFS.downloadFile({fromUrl: apkUrl, toFile: downloadDest});
    const result = await ret.promise;

    if (result.statusCode === 200) {
      const installPermission = await requestInstallPermission();
      if (!installPermission) return;
      Linking.openURL(`file://${downloadDest}`);
    }
  } catch (error) {
    console.error('خطا در دانلود و نصب خودکار:', error);
  }
};

// ==========================
// بررسی نسخه و اجرای آپدیت خودکار
// ==========================
export const autoUpdateApp = async () => {
  try {
    // const response = await fetch('https://yourdomain.com/api/app-version');
    // const data = await response.json();
    const currentVersion = getCurrentVersion();
    console.log('currentVersion', currentVersion);
    // if (compareVersions(data?.latest_version, currentVersion) > 0) {
    //   await downloadAndInstallApk(data?.apk_url);
    // }
  } catch (error) {
    console.error('خطا در بررسی آپدیت خودکار:', error);
  }
};
